<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <a :href="url" :class="styles" :aria-label="label">
    <component :is="getIcon(icon as Icon)" :color="iconColor"></component>
  </a>
</template>

<script lang="ts" setup>
import { defineProps, toRefs, computed } from "vue";
import { Icon } from "@/util/constants";
import Facebook from "@atoms/IconLink/Facebook.ce.vue";
import Instagram from "@atoms/IconLink/Instagram.ce.vue";
import LinkedIn from "@atoms/IconLink/LinkedIn.ce.vue";
import MailTo from "@atoms/IconLink/MailTo.ce.vue";
import Arrow from "@atoms/IconLink/Arrow.ce.vue";
import Xicon from "@atoms/IconLink/Xicon.ce.vue";

const props = defineProps({
  theme: {
    type: String,
    default: "dark",
  },
  url: {
    type: String,
    default: "/",
  },
  icon: {
    type: String,
    default: "Facebook",
  },
  classes: {
    type: String,
    default: "",
  },
  isUmbraco: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
});

const { theme, url, icon, classes, label } = toRefs(props);
const iconColor = theme.value === "dark" ? "fill-white" : "fill-aubergine";

const styles = computed(() => {
  return `border-2 border-typography-20 rounded-full ${classes.value} w-[52px] h-[52px] py-[14px] inline-block group hover:border-orange
  transition-colors`;
});

function getIcon(name: Icon) {
  switch (name) {
    case Icon.FACEBOOK:
      return Facebook;
    case Icon.INSTAGRAM:
      return Instagram;
    case Icon.LINKEDIN:
      return LinkedIn;
    case Icon.MAILTO:
      return MailTo;
    case Icon.ARROW:
      return Arrow;
    case Icon.TWITTER:
      return Xicon;
    default:
      return Arrow;
  }
}
</script>
